var map = {
	"./Bank.json": 1025,
	"./BankFactory.json": 1026,
	"./CrosslinkShip.json": 1027,
	"./CrosslinkShipFactory.json": 1028,
	"./DeveloperAuthorizer.json": 1029,
	"./Dragon.json": 1030,
	"./DragonFactory.json": 1031,
	"./Encrypt.json": 1032,
	"./EncryptFactory.json": 1033,
	"./Ethernaut.json": 307,
	"./FakeFibonacciBank.json": 1034,
	"./FakeFibonacciFactory.json": 1035,
	"./FakeFibonacciLib.json": 1036,
	"./Fomo4D.json": 1037,
	"./Fomo4DFactory.json": 1038,
	"./Freeshop.json": 1039,
	"./FreeshopFactory.json": 1040,
	"./Guard.json": 1041,
	"./GuardLibrary.json": 1042,
	"./Instance.json": 1043,
	"./InstanceFactory.json": 1044,
	"./Level.json": 1045,
	"./MorganStark.json": 1046,
	"./MorganStarkFactory.json": 1047,
	"./Ownable.json": 1048,
	"./PaperScissorsStone.json": 1049,
	"./PaperScissorsStoneFactory.json": 1050,
	"./StrongBox.json": 1051,
	"./StrongBoxFactory.json": 1052,
	"./University.json": 1053,
	"./UniversityFactory.json": 1054,
	"./VentureCapital.json": 1055,
	"./VentureCapitalFactory.json": 1056
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 507;



//////////////////
// WEBPACK FOOTER
// ./build/contracts ^\.\/.*\.json$
// module id = 507
// module chunks = 0